export const imageUrlAlt = (event, rights) => {
    if (
        rights === "Restricted access to the UPC academic community" ||
        rights === "Restricted access to the CSUC academic community"
    ) {
        event.target.src = require("@/assets/images/restricted2.png");
    } else {
        //aqui tenia locked.png
        event.target.src = require("@/assets/images/restricted2.png");
    }
};

export const reverseFacetData = (array) => {
    let valor;
    let arrayResult = [];
    for (let i = array.length - 1; i >= 0; i--) {
        if (i % 2 === 0) {
            arrayResult.push(array[i], valor);
        } else {
            valor = array[i];
        }
    }
    return arrayResult;
};


export const colorSeriesChart = (nameSerie) => {
    //TODO poner los valores de las etiquetas cuando este traducido
    let colorSerie
    if(nameSerie === 'Examen' || nameSerie === 'Examen' || nameSerie === 'Exam') colorSerie = '#a8c8ff'
    else if(nameSerie === 'Llibre' || nameSerie === 'Libro' || nameSerie === 'Book') colorSerie = '#96b9f3'
    else if(nameSerie === 'Audiovisual' || nameSerie === 'Audiovisual' || nameSerie === 'Audiovisual') colorSerie = '#84a9e6'
    else if(nameSerie === 'Treball d\'assignatura' || nameSerie === 'Trabajo de asignatura' || nameSerie === 'Coursework') colorSerie = '#72a0d9'
    else if(nameSerie === 'autoriaLlibre') colorSerie = '#6091cc'
    else if(nameSerie === 'autoriaCapitolCatalegExposicio') colorSerie = '#4e82bf'
    else if(nameSerie === 'edicioCatalegExposicio') colorSerie = '#3c73b2'
    else if(nameSerie === 'autoriaSoftware') colorSerie = '#2a64a5'
    else if(nameSerie === 'autoriaCapitolLlibre') colorSerie = '#185592'
    else if(nameSerie === 'Apunts' || nameSerie === 'Apuntes' || nameSerie === 'Lecture notes') colorSerie = '#06467f'
    else if(nameSerie === 'Problema, exercici' || nameSerie === 'Problema, ejercicio' || nameSerie === 'Problem statement, exercise') colorSerie = '#003f6b'
    else if(nameSerie === 'Pràctica' || nameSerie === 'Práctica' || nameSerie === 'Practice') colorSerie = '#00314e'
    else if(nameSerie === 'Altres' || nameSerie === 'Otros' || nameSerie === 'Other') colorSerie = '#00223a'
    else if(nameSerie === 'Programari' || nameSerie === 'Software' || nameSerie === 'Software') colorSerie = '#001525'
    else if(nameSerie === 'Imatge' || nameSerie === 'Imagen' || nameSerie === 'Image') colorSerie = '#00050f'
    else if(nameSerie === 'Sound') colorSerie = '#00000a'
    else if(nameSerie === 'Exercici de pràctiques' || nameSerie === 'Ejercicio de prácticas' || nameSerie === 'Practical exercise') colorSerie = '#000000'

    //else if(nameSerie === 'Proposta de tesi' || nameSerie === 'Propuesta de tesis' || nameSerie === 'Doctoral thesis proposal') colorSerie = '#8eee65'
    //else if(nameSerie === 'Treball professional' || nameSerie === 'Trabajo profesional' || nameSerie === 'Professional work') colorSerie = '#f85904'
    //else if(nameSerie === 'Projecte de tesi' || nameSerie === 'Proyecto de tesis' || nameSerie === 'Doctoral thesis project') colorSerie = '#02582b'
    //else if(nameSerie === 'Treball de recerca tutelat' || nameSerie === 'Trabajo de investigación tutelado' || nameSerie === 'Tutored research work') colorSerie = '#a15404'
    //else if(nameSerie === 'Projecte de col·laboració' || nameSerie === 'Proyecto de colaboración' || nameSerie === 'Collaborative project') colorSerie = '#6ac9b6'
    //else if(nameSerie === 'Projecte per a l\'homologació del títol' || nameSerie === 'Proyecto para la homologación del título' || nameSerie === 'Recognition of foreign diploma') colorSerie = '#ad0202'

    //Activitat docent
    else if(nameSerie === 'Projecte Final de Màster UPC' || nameSerie === 'Proyecto final de máster UPC' || nameSerie === 'UPC Master thesis') colorSerie = '#a8ff98'
    else if(nameSerie === 'estadaCentreRDI') colorSerie = '#92e68b'
    else if(nameSerie === 'Treball Final de Grau' || nameSerie === 'Trabajo final de grado' || nameSerie === 'Bachelor thesis') colorSerie = '#7cdc7e'
    else if(nameSerie === 'Projecte/Treball Final de Carrera' || nameSerie === 'Proyecto/Trabajo final de carrera' || nameSerie === 'Master thesis (pre-Bologna period)') colorSerie = '#66d671'
    else if(nameSerie === 'Treball de projecte' || nameSerie === 'Trabajo de proyecto' || nameSerie === 'Project work') colorSerie = '#58cc6a'
    else if(nameSerie === 'Projecte Final de Màster Oficial' || nameSerie === 'Projecte Final de Màster Oficial' || nameSerie === 'Master thesis') colorSerie = '#4fc364'
    else if(nameSerie === 'Tesina' || nameSerie === 'Tesina' || nameSerie === 'Minor thesis') colorSerie = '#38b457'
    else if(nameSerie === 'assignaturesImpartidas') colorSerie = '#21a14a'


    //Innocavacio Docent
    else if(nameSerie === 'autoriaArticleRevista') colorSerie = '#ffcf87'
    else if(nameSerie === 'presentacioTreballPresentatEnCongres') colorSerie = '#ffbf71'
    else if(nameSerie === 'participacioProjecteInnovacioDocent') colorSerie = '#ffaf5a'
    else if(nameSerie === 'participacioProjecteRDICompetitiu') colorSerie = '#ffa144'
    else if(nameSerie === 'participacioProjecteRDINoCompetitiu') colorSerie = '#ff902e'
    else if(nameSerie === 'imparticioConferenciaPresentat') colorSerie = '#ff7f18'




    // Formacio
    else if(nameSerie === 'altreFormacioRebuda') colorSerie = '#f12828'
    else if(nameSerie === 'presentacioTreballPresentatEnCursSeminari') colorSerie = '#ff8080'


    //Premis
    else if(nameSerie === 'obtencioPremi') colorSerie = '#fff1a1'

    //Tutories
    else if(nameSerie === 'curricular') colorSerie = '#e0aaff'
    else if(nameSerie === 'extracurricular') colorSerie = '#bb80ff'

    else colorSerie = 'black'
    return colorSerie
};


export const colorSeriesBlocksChart = (nameSerie) => {
    //TODO poner los valores de las etiquetas cuando este traducido
    let colorSerie
    if(nameSerie === 'subtipus') colorSerie = '#2a64a5'
    else if(nameSerie === 'activitat_subtipus_docencia') colorSerie = '#4fc364'
    else if(nameSerie === 'activitat_subtipus_innovacio') colorSerie = '#ffa144'
    else if(nameSerie === 'activitat_subtipus_formacio') colorSerie = '#f12828'
    else if(nameSerie === 'activitat_subtipus_premis') colorSerie = '#fff1a1'
    else if(nameSerie === 'activitat_subtipus_tutoria') colorSerie = '#bb80ff'
    else colorSerie = 'black'
    return colorSerie
};


export const colorSeriesRightsChart = (nameSerie) => {
    let colorSerie
    if(nameSerie === 'Accés obert' || nameSerie === 'Acceso abierto' || nameSerie === 'Open Access') colorSerie = '#6dd067'
    else if(nameSerie === 'Accés restringit a la comunitat UPC' || nameSerie === 'Acceso restringido a la comunidad UPC' || nameSerie === 'Restricted access to the UPC academic community') colorSerie = '#5b86b4'
    else if(nameSerie === 'Accés restringit per decisió de l\'autor' || nameSerie === 'Acceso restringido por decisión del autor' || nameSerie === 'Restricted access - author\'s decision') colorSerie = '#e39393'
    else if(nameSerie === 'Accés restringit per acord de confidencialitat' || nameSerie === 'Acceso restringido por acuerdo de confidencialidad' || nameSerie === 'Restricted access - confidentiality agreement') colorSerie = '#dc4c4c'
    else if(nameSerie === 'Accés restringit a la comunitat acadèmica del CSUC' || nameSerie === 'Acceso restringido a la comunidad académica del CSUC' || nameSerie === 'Restricted access to the CSUC academic community') colorSerie = '#5db8cc'
    else if(nameSerie === 'Accés restringit per política de l\'editorial' || nameSerie === 'Acceso restringido por política de la editorial' || nameSerie === 'Restricted access - publisher\'s policy') colorSerie = '#d38da2'
    else colorSerie = 'black'
    return colorSerie
};

export const cursActual = (any, cuatrimestre) => {
    // Obtenemos la fecha actual
    const fechaActual = new Date();
    const anyActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1; // Los meses en JavaScript van de 0 a 11

    // Definimos los rangos de los cuatrimestres
    const cuatrimestre1Inicio = 9; // Septiembre
    const cuatrimestre1Fin = 1;    // Enero del siguiente año
    const cuatrimestre2Inicio = 2; // Febrero
    const cuatrimestre2Fin = 8;    // Agosto

    // Verificamos si el año proporcionado coincide con el año académico actual
    if (any === anyActual || any === anyActual - 1) {
        // Si el cuatrimestre es 1
        if (cuatrimestre === 1) {
            // Verificamos si estamos en el rango del cuatrimestre 1
            if ((mesActual >= cuatrimestre1Inicio && mesActual <= 12) ||
                (mesActual >= 1 && mesActual <= cuatrimestre1Fin)) {
                // Si el año proporcionado es el año anterior (anyActual - 1) y estamos en el cuatrimestre 1, es correcto
                if (any === anyActual - 1 && mesActual >= cuatrimestre1Inicio) {
                    return true;
                }
                // Si el año proporcionado es el año actual (anyActual) y estamos en el cuatrimestre 1, es correcto
                if (any === anyActual && mesActual <= cuatrimestre1Fin) {
                    return true;
                }
            }
        }
        // Si el cuatrimestre es 2
        else if (cuatrimestre === 2) {
            // Verificamos si estamos en el rango del cuatrimestre 2
            if (mesActual >= cuatrimestre2Inicio && mesActual <= cuatrimestre2Fin) {
                // Si el año proporcionado es el año anterior (anyActual - 1) y estamos en el cuatrimestre 2, es correcto
                if (any === anyActual - 1) {
                    return true;
                }
            }
        }
    }

    // Si no se cumple ninguna de las condiciones anteriores, devolvemos false
    return false;
};


export const obtenerCursActual = () => {
    /*const hoy = new Date();
    const añoActual = hoy.getFullYear();
    const mesActual = hoy.getMonth() + 1; // getMonth() es 0-based

    let cursoInicio, cursoFin, cuatrimestre;

    if (mesActual >= 9) {
        // Si estamos de septiembre a diciembre, es el primer cuatrimestre del curso actual
        cursoInicio = añoActual;
        cursoFin = añoActual + 1;
        cuatrimestre = 1;
    } else if (mesActual >= 2 && mesActual <= 8) {
        // Si estamos de febrero a agosto, es el segundo cuatrimestre del curso anterior
        cursoInicio = añoActual - 1;
        cursoFin = añoActual;
        cuatrimestre = 2;
    } else {
        // Si estamos en enero, sigue siendo el primer cuatrimestre del curso anterior
        cursoInicio = añoActual - 1;
        cursoFin = añoActual;
        cuatrimestre = 1;
    }

    //return `${cursoInicio}/${cursoFin} - Q${cuatrimestre}`;
    return {
        any: cursoInicio,
        curs: `${cursoInicio}/${cursoFin}`,
        q: cuatrimestre
    };*/
    const hoy = new Date();
    const añoActual = hoy.getFullYear();
    const mesActual = hoy.getMonth() + 1; // getMonth() es 0-based

    let cursoInicio, cursoFin;

    if (mesActual >= 9) {
        // Si estamos de septiembre a diciembre, es el curso actual
        cursoInicio = añoActual;
        cursoFin = añoActual + 1;
    } else {
        // Si estamos de enero a agosto, el curso actual es el anterior
        cursoInicio = añoActual - 1;
        cursoFin = añoActual;
    }

    return {
        any: cursoInicio,
        curs: `${cursoInicio}/${cursoFin}`
    };
};

